<template>
  <v-row>
    <v-col cols="12">
      <loader v-if="loadingState" />
      <div v-else>
        <div v-if="sectionDoesNotContainData" class="text-center">
          <no-data />
        </div>

        <h1 class="text-center mb-4 py-1" style="background-color: #bbdefb">
          {{ this.submenuName }}
        </h1>
        <div v-if="description">
          <description :description="description" />
        </div>
        <div>
          <v-row>
            <v-col
              cols="12"
              xl="3"
              lg="3"
              md="4"
              sm="6"
              v-for="(image, index) in images"
              :key="index"
            >
              <image-modal :imgData="image" />
            </v-col>
          </v-row>
        </div>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import * as api from "../config/api.js";
import ImageModal from "../components/modal/imageModal.vue";
import Description from "../components/description.vue";
export default {
  beforeMount() {
    this.getData();
  },
  components: {
    ImageModal,
    Description,
  },
  computed: {},
  data() {
    return {
      loadingState: false,
      id: this.$route.params.id,
      images: [],
      description: null,
      sectionDoesNotContainData: false,
      submenuName: null,
    };
  },
  methods: {
    reset() {
      this.images = [];
      this.description = null;
      this.submenuName = null;
      this.loadingState = false;
      this.sectionDoesNotContainData = false;
    },
    getData() {
      this.reset();
      this.loadingState = true;
      this.$http
        .get(api.CO_CURRICULAM + "/" + this.id)
        .then((res) => {
          if (res.data != null) {
            this.images = res.data.images;
            this.description = res.data.description;
            this.submenuName = res.data.submenuName;
          } else {
            this.sectionDoesNotContainData = true;
          }
        })
        .catch((error) => {
          console.log(" Error=======>", error.response.data);
        })
        .finally(() => {
          this.loadingState = false;
        });
    },
  },
  mounted() {},
  props: {},
  updated() {},
  watch: {
    "$route.params"() {
      this.id = this.$route.params.id;
      this.getData();
    },
  },
};
</script>

<style scoped>
.description {
  font-size: 20px;
  word-spacing: 2px;
  word-break: break-all;
  text-align: justify;
}
</style>
